import { FileCopy } from '@mui/icons-material';
import { Box, IconButton, Tooltip, TooltipProps, Typography, tooltipClasses } from '@mui/material';
import { IStoreState } from '@store/index';
import Utils from '@utils/index';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components'

export const NoMaxWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 'none',
  },
});

type StreamTooltipProps = {
  stream: VideoStream;
}

const StreamTooltip: React.FC<StreamTooltipProps> = (props) => {
  const { stream } = props;

  const isSuperAdministrator = useSelector((store: IStoreState) => store.session.isSuperAdministrator);

  return (
    <NoMaxWidthTooltip
      arrow={true}
      disableFocusListener
      placement="top-start"
      style={{ maxWidth: 'none' }}
      title={
        <Box
          onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
          display="flex"
          flexDirection="column"
        >
          {isSuperAdministrator && stream.defaultName &&
            <TooltipLine
              title={"Camera name"}
              value={stream.defaultName}
            />
          }
          <TooltipLine
            title={"KVS Name"}
            value={stream.kvsName}
          />
          <TooltipLine
            title={"IP"}
            value={Utils.RegEx.findIPAddress(stream.rtspUrl)}
          />
          {isSuperAdministrator && stream.sourceType &&
            <TooltipLine
              title={"Source type"}
              value={stream.sourceType}
            />
          }
          {isSuperAdministrator && stream.iotThingName &&
            <TooltipLine
              title={"Edge device"}
              value={stream.iotThingName}
            />
          }
          {isSuperAdministrator && stream.iotThingName &&
            <TooltipLine
              title={"Instance ID"}
              value={stream.deviceShadowName || "-"}
            />
          }
          {isSuperAdministrator && stream.rtspUrl &&
            <TooltipLine
              title={"Streaming RTSP Address"}
              value={stream.rtspUrl}
            />
          }
          {isSuperAdministrator && stream.rtspUrlProc &&
            <TooltipLine
              title={"Processing RTSP Address"}
              value={stream.rtspUrlProc}
            />
          }
        </Box>
      }
    >
      <Typography
        variant="subtitle1"
        noWrap={true}
        style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}
      >
        {Utils.Stream.getStreamName(stream)}
      </Typography>
    </NoMaxWidthTooltip>
  )
}

const TooltipLine: React.FC<{ title: string; value: string; }> = (props) => {
  const { title, value } = props;

  return (
    <Box
      onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}
      display="flex"
      flexDirection="row"
      alignItems="center"
    >
      <Typography variant="body2"><b>{`${title}: `}</b>{`${value}`}</Typography>
      <IconButton
        style={{ width: '1rem', height: '1rem' }}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          navigator.clipboard.writeText(value);
        }}
        size="large"
        data-cy="stream-copy-name-icon-button"
      >
        <FileCopy style={{ width: '1rem', height: '1rem', color: 'white' }} />
      </IconButton>
    </Box>
  )
}

export default StreamTooltip;
